module.exports = "<div id=\"add-email\">\n    <mat-form-field class=\"w-100-p\">\n        <input matInput [(ngModel)]=\"alterEmail\" placeholder=\"Enter Email\">\n    </mat-form-field>\n    <div mat-dialog-actions>\n        <button mat-raised-button color=\"accent\" (click)=\"saveEmail()\">Save</button>\n        <button mat-raised-button [mat-dialog-close]=\"false\" (click)=\"cancel()\">Close</button>\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/email-popup/emailPopup.component.html
// module id = ../../../../../src/app/main/content/apps/e-commerce/solutionForm/email-popup/emailPopup.component.html
// module chunks = main